<template>
    <FormSection
        :full-height="false"
        :title="profileTitle"
        title-class="ps-2"
        :show-product-pill="true"
        :application-id="application"
        :show-background="true"
        :use-gray-theme="true"
        :cancel="cancel"
    >
        <template #content>
            <section v-if="isLoading" class="p-5 d-flex flex-column text-center text-primary">
                <i class="fa fa-spinner fa-spin font-size-5xl me-2 animated slow flash infinite"></i>
                <span class="mt-1">
                    <b>Loading...</b>
                </span>
            </section>
            <section v-if="!isLoading">
                <div class="p-3 profile-container">
                    <div class="sub-container col-12">
                        <div class="row g-0 col-12 ps-3 mt-3 pt-1">
                            <div class="col-3">
                                <p class="mb-1"><strong>Name</strong></p>
                                <p>{{ fullName }}</p>
                            </div>
                            <div class="col-3">
                                <p class="mb-1"><strong>MRN</strong></p>
                                <p id="start-of-care">{{ patientDetails?.Mrn || "N/A" }}</p>
                            </div>
                            <div class="col-3 ps-5">
                                <p class="mb-1"><strong>Gender</strong></p>
                                <p id="dnr">{{ userGender }}</p>
                            </div>
                            <div class="col-3">
                                <p class="mb-1"><strong>DOB</strong></p>
                                <p>{{ DOB }}</p>
                            </div>
                        </div>
                        <div class="row g-0 col-12 ps-3 mt-2 pt-1">
                            <div class="col-3">
                                <p class="mb-1"><strong>Start Of Care</strong></p>
                                <p id="start-of-care">{{ startOfCare }}</p>
                            </div>
                            <div class="col-3">
                                <p class="mb-1">
                                    <strong>{{ carePeriodTitle }}</strong>
                                </p>
                                <p>{{ carePeriod }}</p>
                            </div>
                            <div class="col-3 ps-5">
                                <p class="mb-1"><strong>DNR</strong></p>
                                <p id="dnr">{{ patientDetails?.IsDnr === true ? "Yes" : "No" }}</p>
                            </div>
                        </div>
                    </div>
                    <div class="sub-container mt-2 col-12">
                        <div class="row g-0 col-12 ps-3 mt-2 pt-1">
                            <div class="col-12">
                                <p class="mb-1"><strong>Primary Diagnosis</strong></p>
                                <p>{{ patientDetails?.Diagnosis || "N/A" }}</p>
                            </div>
                        </div>
                    </div>
                    <div class="sub-container mt-2 col-12">
                        <div class="row g-0 col-12 ps-3 mt-2 pt-1">
                            <div class="col-12">
                                <p class="mb-1"><strong>Primary Phone</strong></p>
                                <p>{{ primaryPhone }}</p>
                            </div>
                            <div class="col-4">
                                <p class="mb-1"><strong>Address Line 1</strong></p>
                                <p>{{ patientDetails?.AddressLine1 || "N/A" }}</p>
                            </div>
                            <div class="col-8">
                                <p class="mb-1"><strong>Address Line 2</strong></p>
                                <p>{{ patientDetails?.AddressLine2 || "N/A" }}</p>
                            </div>
                            <div class="col-4">
                                <p class="mb-1"><strong>City</strong></p>
                                <p>{{ patientDetails?.City || "N/A" }}</p>
                            </div>
                            <div class="col-3">
                                <p class="mb-1"><strong>State</strong></p>
                                <p>{{ patientDetails?.State || "N/A" }}</p>
                            </div>
                            <div class="col-2">
                                <p class="mb-1"><strong>Postal</strong></p>
                                <p>
                                    {{ patientDetails?.PostalCode ? formatZipCode(patientDetails.PostalCode) : "N/A" }}
                                </p>
                            </div>
                            <div class="col-3">
                                <p class="mb-1"><strong>County</strong></p>
                                <p>{{ patientDetails?.County || "N/A" }}</p>
                            </div>
                        </div>
                    </div>
                    <div class="sub-container mt-2 col-12">
                        <div class="row g-0 col-12 ps-3 mt-2 pt-1">
                            <div class="col-4">
                                <p class="mb-1"><strong>Primary Emergency Contact</strong></p>
                                <p>
                                    {{
                                        patientDetails?.EmergencyPrimaryContactName?.trim()
                                            ? patientDetails.EmergencyPrimaryContactName
                                            : "N/A"
                                    }}
                                </p>
                            </div>
                            <div class="col-5">
                                <p class="mb-1"><strong>Primary Emergency Phone</strong></p>
                                <p>{{ emergencyPhone }}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </template>
    </FormSection>
</template>

<style lang="scss" src="./PatientProfile.scss"></style>
<script lang="ts" src="./PatientProfile.ts"></script>
